'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_1 = require('tslib');
var create = require('./create');

/**
 * Create Simple Functional Component
 */
function createSimpleFC(options) {
    var _a = options.tag, tag = _a === void 0 ? 'div' : _a, name = options.name, className = options.className, updateData = options.updateData;
    return create.create(name, {
        name: name,
        functional: true,
        render: function (createEL, ctx) {
            // 将 nativeOn 转化为 on
            if (ctx.data.nativeOn) {
                ctx.data.on = tslib_1.__assign({}, ctx.data.on, ctx.data.nativeOn);
                delete ctx.data.nativeOn;
            }
            if (className) {
                mergeClass(ctx, className);
            }
            if (updateData) {
                updateData(ctx);
            }
            return createEL(tag, ctx.data, ctx.children);
        }
    });
}
// 合并 class 对象
function mergeClass(ctx, className) {
    var data = ctx.data;
    if (typeof className === 'string') {
        data.staticClass = (data.staticClass || '') + " " + className;
    }
    else {
        data.class = toArray(data.class).concat(toArray(className(ctx)));
    }
}
function toArray(item) {
    return item ? Array.isArray(item) ? item : [item] : [];
}

exports.createSimpleFC = createSimpleFC;
